import React from "react";
import SwipeRow from "../ui/SwipeRow";
import { formatWhen } from "./groupConversations";
import { plural } from "../ui/text";

// One chat in the list: title, when, and how many messages. The swipe-to-delete behaviour is SwipeRow's.
export default function HistoryRow({ conversation, active, onSelect, onDelete }) {
  const title = conversation.title || "New conversation";
  return (
    <SwipeRow
      active={active}
      onTap={() => onSelect(conversation.id)}
      onDelete={() => onDelete(conversation)}
      deleteLabel={`Delete chat: ${title}`}
    >
      <div className="hr-line">
        <span className="hr-title">{title}</span>
        <time className="hr-time">{formatWhen(conversation.updated_at)}</time>
      </div>
      <p className="hr-meta">{plural(conversation.message_count || 0, "message", "messages")}</p>
    </SwipeRow>
  );
}
